import React, { useState, useEffect } from 'react';
import './MonitorMessages.css';
import { getAllMessages } from '../../clientServices/MessagesService';
import { useNavigate, useLocation } from 'react-router-dom';
import logoImg from './logo.png';

const MonitorMessages = ({ messages, setMessages }) => {


    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await getAllMessages();
                const activeMessages = response.data.data.filter(message => message.Status === true);
                setMessages(activeMessages);
                // console.log(response.data);
            } catch (error) {
                console.error('Error fetching messages:', error);
            }
        };

        fetchMessages();
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const role = location.state;

    //const activeMessages = messages?messages.filter(message => message.Status):null;
    const goToHomePage = () => {
        navigate('/admin', { state: role });
    };

    return (
        <>
            {messages.length > 0 && (
                <div className='messagesContainer'>

                    <div className='messageDisplay'>
                        <div className='logo-cont-monitor' onClick={goToHomePage}>
                            <img className='logo-img-monitor' alt='logo' src={logoImg} />
                        </div>
                        <div className='messagesMonitorContainer'>

                            <div className='messageList'>
                                {messages.map(message => (
                                    <div key={message.ID} className='messageItem'>
                                        {message.Message}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            )}
        </>
    );
};

export default MonitorMessages;
